import React from 'react';
import PropTypes from 'prop-types';
import { range } from 'lodash';
import moment from 'moment';

import DateInput from '../DateInput';
import getTime, { getPeriod } from '../../utils/periodTime';

import dataTestValue from '../../utils/testUtils';
import { getTranslationFor } from 'src/locale/lang';

class DateRangeInput extends React.Component {
    static propTypes = {
        value: PropTypes.shape({
            startDate: PropTypes.string,
            endDate: PropTypes.string
        }),
        maxDate: PropTypes.string,
        showPredefined: PropTypes.bool,
        onChange: PropTypes.func,
        'data-test': PropTypes.string,
        endLabel: PropTypes.string,
        startLabel: PropTypes.string
    };

    static defaultProps = {
        value: {
            startDate: moment().subtract(7, 'days').format('YYYY-MM-DD'),
            endDate: moment().format('YYYY-MM-DD')
        },
        maxDate: moment().format('YYYY-MM-DD'),
        showPredefined: false
    };

    constructor(props, context) {
        super(props, context);

        this.state = this.getState(props);
    }

    getState(props) {
        return {
            value: props.value
        };
    }

    changeTime(e) {
        let time = e.target.value;

        if (!time) {
            return;
        }

        let value = getTime(time);

        this.setState({
            value
        });

        this.onChange(value);
    }

    changeStartDate(startDate) {
        let value = {
            ...this.state.value,
            startDate
        };

        this.setState({
            value
        });

        this.onChange(value);
    }

    changeEndDate(endDate) {
        let value = {
            ...this.state.value,
            endDate
        };

        this.setState({
            value
        });

        this.onChange(value);
    }

    onChange(value) {
        if (this.props.onChange) {
            this.props.onChange(value || this.state.value);
        }
    }

    render() {
        const { startDate, endDate } = this.state.value;
        const { maxDate, showPredefined, startLabel, endLabel} = this.props;
        const label = this.props['data-test'];

        let maxStartDate;
        if (endDate) {
            maxStartDate = moment(
                moment(maxDate).diff(moment(endDate), 'days') < 0 ? maxDate : endDate
            );
        }

        let time = getPeriod(startDate, endDate);

        const startInput = (
            <DateInput
                label={ getTranslationFor('DATE_RANGE_FROM_LABEL') }
                maxDate={ maxStartDate }
                value={ startDate }
                onChange={ this.changeStartDate.bind(this)}
            />
        );

        const endInput = (
            <DateInput
                label={ getTranslationFor('DATE_RANGE_TO_LABEL') }
                minDate={ startDate ? moment(startDate) : void 0 }
                maxDate={ moment(maxDate) }
                value={ endDate }
                onChange={ this.changeEndDate.bind(this)}
            />
        );

        if (!showPredefined) {
            return (
                <div className="row">
                    <div className="col-6" data-test={ dataTestValue(label, 'start') }>
                        { startInput }
                        <label className="labelName">{ startLabel || getTranslationFor('DATE_RANGE_FROM_LABEL') }</label>
                    </div>
                    <div className="col-6" data-test={ dataTestValue(label, 'end') }>
                        { endInput }
                        <label className="labelName">{ endLabel || getTranslationFor('DATE_RANGE_TO_LABEL') }</label>
                    </div>
                </div>
            );
        }

        const predefinedInput = (
            <div className="select-wrapper">
                <select value={ time } onChange={ this.changeTime.bind(this)}>
                    <option value="custom" style={ { display: 'none' } }>Custom date</option>
                    <option value="today">Today</option>
                    <option value="3-days">Last 3 days</option>
                    <option value="7-days">Last 7 days</option>
                    <option value="week">This week</option>
                    <option value="month">This month</option>
                </select>
            </div>
        );

        return (
            <div className="row">
                <div className="col-4">
                    { startInput }
                </div>
                <div className="col-4">
                    { endInput }
                </div>
                <div className="col-4">
                    { predefinedInput }
                </div>
            </div>
        );
    }
}

export default DateRangeInput;
